import React, { useCallback } from "react";
import styles from "./deductions.module.scss";
import Input from "components/Input";
import Select from "components/Select";
import SubmitButton from "components/SubmitButton";
import { cn } from "utils";
import { options } from "constants/options";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ChildSupportDeductionInputs, childSupportDeductionSchema } from "./const";

const AddEditChildSupportDeduction = () => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(childSupportDeductionSchema)
    });

    console.log("errorserrorsssss", errors);

    const onSubmit = useCallback((values) => {
        console.log("values", values);
    }, [])

    return (
        <form
            className={cn("container-spacing pt-3 pb-5")}
            onSubmit={handleSubmit(onSubmit)}
        >
            <h3 className={cn("title mt-2")}>Add Deduction</h3>
            <div>
                <div>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Assigned Employee"
                                    fullWidth
                                    variant="flat"
                                    options={[]}
                                    {...register(ChildSupportDeductionInputs.ASSIGNED_EMPLOYEE)}
                                    error={!!errors[ChildSupportDeductionInputs.ASSIGNED_EMPLOYEE]}
                                    errorText={errors[ChildSupportDeductionInputs.ASSIGNED_EMPLOYEE]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={cn("info-title mt-3")}>General Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Input
                                    label="Description*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.DESCRIPTION)}
                                    error={!!errors[ChildSupportDeductionInputs.DESCRIPTION]}
                                    errorText={errors[ChildSupportDeductionInputs.DESCRIPTION]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Start Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(ChildSupportDeductionInputs.START_DATE)}
                                    error={!!errors[ChildSupportDeductionInputs.START_DATE]}
                                    errorText={errors[ChildSupportDeductionInputs.START_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="End Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(ChildSupportDeductionInputs.END_DATE)}
                                    error={!!errors[ChildSupportDeductionInputs.END_DATE]}
                                    errorText={errors[ChildSupportDeductionInputs.END_DATE]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Deduction Amount*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.DEDUCTION_AMOUNT)}
                                    error={!!errors[ChildSupportDeductionInputs.DEDUCTION_AMOUNT]}
                                    errorText={errors[ChildSupportDeductionInputs.DEDUCTION_AMOUNT]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Deduction Gap*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.DEDUCTION_GAP)}
                                    error={!!errors[ChildSupportDeductionInputs.DEDUCTION_GAP]}
                                    errorText={errors[ChildSupportDeductionInputs.DEDUCTION_GAP]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={cn("info-title mt-3")}>Child Support Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Case #*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.CASE)}
                                    error={!!errors[ChildSupportDeductionInputs.CASE]}
                                    errorText={errors[ChildSupportDeductionInputs.CASE]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="FIPS Code"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.FIPS_CODE)}
                                    error={!!errors[ChildSupportDeductionInputs.FIPS_CODE]}
                                    errorText={errors[ChildSupportDeductionInputs.FIPS_CODE]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Select
                                    label="Select Agency"
                                    fullWidth
                                    options={options}
                                    {...register(ChildSupportDeductionInputs.AGENCY)}
                                    error={!!errors[ChildSupportDeductionInputs.AGENCY]}
                                    errorText={errors[ChildSupportDeductionInputs.AGENCY]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Issue Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(ChildSupportDeductionInputs.ISSUE_DATE)}
                                    error={!!errors[ChildSupportDeductionInputs.ISSUE_DATE]}
                                    errorText={errors[ChildSupportDeductionInputs.ISSUE_DATE]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Payment Amount*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.PAYMENT_AMOUNT)}
                                    error={!!errors[ChildSupportDeductionInputs.PAYMENT_AMOUNT]}
                                    errorText={errors[ChildSupportDeductionInputs.PAYMENT_AMOUNT]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Max Percentage*"
                                    fullWidth
                                    variant="flat"
                                    {...register(ChildSupportDeductionInputs.MAX_PERCENTAGE)}
                                    error={!!errors[ChildSupportDeductionInputs.MAX_PERCENTAGE]}
                                    errorText={errors[ChildSupportDeductionInputs.MAX_PERCENTAGE]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <SubmitButton
                        submitText="Add Deduction"
                    />
                </div>
            </div>
        </form>
    )
}

export default AddEditChildSupportDeduction;